import { Container } from "./styles";

import reactIcon from "../../assets/react-icon.svg";
import linkedin from "../../assets/linkedin.svg";
import githubIcon from "../../assets/github.svg";
import coffeeIcon from "../../assets/kofi_symbol.svg";
//import telegram from '../../assets/telegram.svg'
import facebookIcon from "../../assets/facebook_circle_icon.png"; // instagram-circle.png
// import discordIcon from '../../assets/discord.png'

export function Footer() {
  return (
    <Container className="footer">
      <a href="/" className="logo">
        <span>Ronald</span>
        <span> Ritz</span>
      </a>
      <div>
        <p>
          This Website was made with <img src={reactIcon} alt="React" />
          {/* <span>❤️</span> */}
        </p>
      </div>

      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/ritz-ronald/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a href="https://github.com/bigitp" target="_blank" rel="noreferrer">
          <img src={githubIcon} alt="GitHub" />
        </a>
        {/*<a
          href="https://api.whatsapp.com/send/?phone=%2B919970462941&text=Hello+Anand"
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        {/* <a
          href="https://t.me/CodeVinayak"
          target="_blank"
          rel="noreferrer"
        >
          <img src={telegram} alt="telegram" />
        </a> */}
        <a
          href="hhttps://www.facebook.com/ritz.ronald"
          target="_blank"
          rel="noreferrer"
        >
          <img src={facebookIcon} alt="Instagram" />
        </a>

         <a
          href="https://ko-fi.com/ritzronald"
          target="_blank"
          rel="noreferrer"
        >
          <img src={coffeeIcon} alt="Coffee" />
        </a>

        {/* <a
          href="https://discord.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={discordIcon} alt="Discord" />
        </a> */}
      </div>
    </Container>
  );
}
